import React, { useState, useEffect } from 'react';
import { Modal, Form, Select, Tag, Descriptions, Alert, message } from 'antd';
import { SwapOutlined } from '@ant-design/icons';
import apiClient from '../../../../../api/apiClient';

const { Option } = Select;

const ReasignacionIndividualModal = ({ visible, asignacion, docentes, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!visible) form.resetFields();
  }, [visible, form]);

  const docentesDisponibles = docentes.filter(
    (d) => d.idDocente !== asignacion?.IdDocente && d.Estado !== false
  );

  const handleConfirmar = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      const user = JSON.parse(localStorage.getItem('user')) || {};
      await apiClient.put(`/asignaciones/${asignacion.IdAsignacionDocente}/reasignar-docente`, {
        IdDocenteNuevo: values.IdDocenteNuevo,
        ModificadoPor: String(user.IdUsuario || ''),
      });

      message.success('Docente reasignado correctamente');
      onSuccess();
    } catch (error) {
      const msg = error.response?.data?.error || error.message || 'Error al reasignar';
      message.error(msg);
    } finally {
      setLoading(false);
    }
  };

  if (!asignacion) return null;

  return (
    <Modal
      title={
        <span>
          <SwapOutlined style={{ marginRight: 8, color: '#1677ff' }} />
          Reasignar Docente
        </span>
      }
      open={visible}
      onOk={handleConfirmar}
      onCancel={onCancel}
      okText="Confirmar Reasignación"
      cancelText="Cancelar"
      confirmLoading={loading}
      width={520}
      destroyOnClose
    >
      <Descriptions
        bordered
        size="small"
        column={1}
        style={{ marginBottom: 20 }}
      >
        <Descriptions.Item label="Curso">{asignacion.NombreCurso}</Descriptions.Item>
        <Descriptions.Item label="Grado">{asignacion.NombreGrado}</Descriptions.Item>
        <Descriptions.Item label="Sección">{asignacion.NombreSeccion}</Descriptions.Item>
        <Descriptions.Item label="Jornada">{asignacion.NombreJornada}</Descriptions.Item>
        <Descriptions.Item label="Año">
          <Tag color="blue">{asignacion.Anio}</Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Docente actual">
          <Tag color="orange">{asignacion.NombreDocente}</Tag>
        </Descriptions.Item>
      </Descriptions>

      <Alert
        type="info"
        showIcon
        message="Las unidades, actividades y calificaciones ya registradas se conservan. Solo cambia quién imparte el curso."
        style={{ marginBottom: 20 }}
      />

      <Form form={form} layout="vertical">
        <Form.Item
          name="IdDocenteNuevo"
          label="Nuevo docente"
          rules={[{ required: true, message: 'Selecciona el docente de reemplazo' }]}
        >
          <Select
            placeholder="Selecciona el nuevo docente"
            showSearch
            optionFilterProp="children"
          >
            {docentesDisponibles.map((d) => (
              <Option key={d.idDocente} value={d.idDocente}>
                {d.NombreDocente}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ReasignacionIndividualModal;
